<template>
  <ItemsWaiting style="position: absolute;right: -1vw !important;top: 3vw;z-index: -1;" v-if="is_fetch"/>
  <div v-else>
    <div class="d-flex justify-content-between" v-if="allItems.length">
      <div class="text-right m-4">
        <h5 style="font-size: 1vw !important"></h5>
      </div>
    </div>
    <center v-if="status_approver">
      <div class="alert alert-success w-25">
        تایید نهایی!
      </div>
    </center>
    <center v-if="!status_show && allItems.length">

      <div v-if="seconder_ban" class="alert alert-warning w-50" @click="infoCancelledModal=true">
        <div v-if="this.$cookies.isKey('type_2')">
          کاربرگ توسط مدیر ؛ تایید نشد!
        </div>
        <div v-else>
          این کاربرگ قبلا توسط شما رد شده است و الان اصلاح شده است!

        </div>
      </div>
    </center>
    <center v-if="!status_show">
      <div v-if="approver_ban" @click="infoCancelledModal=true" class="alert alert-info" style="width: 30vw;">
        کاربرگ توسط مدیر سامانه ؛ تایید نشد!
      </div>
    </center>
    <center v-if="status_seconder_step">
      <div v-if="status_seconder" class="alert alert-info w-25">
        در انتظار تایید توسط مدیر
      </div>
      <div v-if="!status_seconder" class="alert alert-info" style="width: 24vw;">
        در انتظار تایید توسط مدیر سامانه
      </div>
    </center>

    <div class="filter-container">
      <div class="row">
        <div class="col-6">
          <p class="fw-bolder">فیلتر براساس وضعیت اقدام</p>
          <select class="form-select" v-model="actionStatus">
            <option value="همه">همه</option>
            <option value="مصوب">مصوب</option>
            <option value="درحال تصویب">درحال تصویب</option>
            <option value="تکمیل شده">تکمیل شده</option>
            <option value="تکمیل نشده">تکمیل نشده</option>
          </select>
        </div>

        <div class="col-6">
          <p class="fw-bolder">فیلتر براساس دوره چرخه</p>
          <select class="form-select" v-model="period">
            <option value="همه">همه</option>
            <option v-for="(event, index) in events" :key="index" :value="event.name">{{ event.name }}</option>
          </select>
        </div>
      </div>
    </div>

    <div class="table-responsive p-5" style="overflow-x:scroll; ">
      <center v-show="!allItems.length">
        <span v-if="$cookies.isKey('type_2') && isWrite">پایش و مراقبت  بهره وری وجود ندارد</span>
        <span v-else-if="!isWrite">دوره ای برای  پایش بهره وری این شرکت فعال نمی باشد
</span>
        <span v-else>
            در انتظار تکمیل کاربرگ توسط دبیرکمیته بهره وری
          </span>
      </center>
      <div style="overflow-y: scroll; height: 30vw;">
        <table class="table table-striped" v-show="allItems.length" style="width: 240vw;">
          <thead>
          <tr style="height: 1vw !important;">
            <th class="sticky-header"><strong>ردیف</strong></th>
            <th class="sticky-header sticky-column" style="width: 24vw;"><strong>مسئله</strong></th>
            <th class="sticky-header" style="width: 12vw;"><strong>سیاست مداخله</strong></th>
            <th class="sticky-header sticky-column sticky-column-two" style="width: 7vw;"><strong>اقدام پیشران</strong>
            </th>
            <th class="sticky-header" style="width: 7vw;"><strong>زمان شروع اقدام</strong></th>
            <th class="sticky-header" style="width: 7vw;"><strong>زمان پایان اقدام</strong></th>
            <th class="sticky-header sticky-column sticky-column-three" style="width: 7vw;"><strong>عنوان سنجه </strong>
            </th>
            <th class="sticky-header"><strong>هدف فصل بهار</strong></th>
            <th class="sticky-header"><strong>میزان پیشرفت فصل بهار</strong></th>
            <th class="sticky-header"><strong>میزان انحراف از هدف فصل بهار</strong></th>
            <th class="sticky-header"><strong>هدف فصل تابستان</strong></th>
            <th class="sticky-header"><strong>میزان پیشرفت فصل تابستان</strong></th>
            <th class="sticky-header"><strong>میزان انحراف از هدف فصل تابستان</strong></th>
            <th class="sticky-header"><strong>هدف فصل پاییز</strong></th>
            <th class="sticky-header"><strong>میزان پیشرفت فصل پاییز</strong></th>
            <th class="sticky-header"><strong>میزان انحراف از هدف فصل پاییز</strong></th>
            <th class="sticky-header"><strong>هدف فصل زمستان</strong></th>
            <th class="sticky-header"><strong>میزان پیشرفت فصل زمستان</strong></th>
            <th class="sticky-header"><strong>میزان انحراف از هدف فصل زمستان</strong></th>
          </tr>
          </thead>
          <tbody>
          <tr class="bg-white" v-for="(item, index) in allItems" :key="item.id">
            <td>{{ index + 1 }}</td>
            <td class="sticky-column">{{ item.problem_title }}</td>
            <td>{{ item.basic_measures_problem }}</td>
            <td class="sticky-column sticky-column-two">{{ item.propulsion }}</td>
            <td>{{ item.date_start_p }}</td>
            <td>{{ item.date_end_p }}</td>
            <td class="sticky-column sticky-column-three">{{ item.title }}</td>
            <td>{{ item.progress_spring }}</td>
            <td>
              <span v-if="spring && item.nature_type"><input v-model="item.target_spring" type="text"
                                                             class="form-control"></span>
              <span v-else>{{ item.target_spring_yes }}</span>
            </td>
            <td>{{ item.spring_deviation }}</td>
            <td>{{ item.progress_summer }}</td>
            <td>
              <span v-if="summer && item.nature_type"><input v-model="item.target_summer" type="text"
                                                             class="form-control"></span>
              <span v-else>{{ item.target_summer_yes }}</span>
            </td>
            <td>{{ item.summer_deviation }}</td>
            <td>{{ item.progress_autumn }}</td>
            <td>
              <span v-if="autumn && item.nature_type"><input v-model="item.target_autumn" type="text"
                                                             class="form-control"></span>
              <span v-else>{{ item.target_autumn_yes }}</span>
            </td>
            <td>{{ item.autumn_deviation }}</td>
            <td>{{ item.progress_winter }}</td>
            <td>
              <span v-if="winter && item.nature_type"><input v-model="item.target_winter" type="text"
                                                             class="form-control"></span>
              <span v-else>{{ item.target_winter_yes }}</span>
            </td>
            <td>{{ item.winter_deviation }}</td>

          </tr>
          </tbody>
        </table>
      </div>
      <hr v-if="allItems.length">
      <br>
      <div class="d-flex align-items-center justify-content-center">
        <button v-if="not_show" style="transform: translateY(0.7vw)" @click.prevent="storeData"
                class="btn btn-submit-1 btn-primary my-2 mx-2">ذخیره
        </button>
        <a v-if="allItems.length"
           :href="`${this.download_url}/KeyActivitiesProblem/all/word/${id_user}?token=${$cookies.get('id_login')}&action_status=${actionStatus}&period=${period}`"
           style="margin-top: 1.3vw;margin-left: 1vw;"
           class="btn btn-primary btn-submit-1">خروجی Word</a>

      </div>
    </div>
  </div>
</template>
<script>
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import {useToast} from "vue-toastification";
import ItemsWaiting from "@/components/Loaders/ItemsWaiting.vue";

const toast = useToast();

export default {
  components: {ItemsWaiting, Vue3PersianDatetimePicker},
  data() {
    return {
      actionStatus: 'تکمیل نشده',
      period: 'همه',
      is_fetch: true,
      status_loading2: false,
      showReSubmit: false,
      acceptCompleteModal: false,

      importModal: false,
      documentsModal: false,
      MissionModal: false,
      KeyDefinitionsModal: false,
      allItems: [],
      documents: [],
      id: '',
      result_one: '',
      result_Two: '',
      title: '',
      titleDoc: '',
      title_attach: '',
      file: '',
      id_two: '',

      target: '',

      title_task: '',
      trustee_device: '',
      partner_device: '',
      start_date_task: '',
      end_date_task: '',
      expected_progress: '',
      key_activities_problems_id: '',
      spring_progress: '',
      summer_progress: '',
      autumn_progress: '',
      winter_progress: '',
      progress: 0,
      deviation: '',
      important_obstacles: '',
      approach: '',
      year_funds: '',
      spring_funds: '',
      summer_funds: '',
      autumn_funds: '',
      event: '',
      winter_funds: '',
      id_user: '',
      id_file: '',
      delete_fileModal: false,
      isWrite: false,
      status_show: false,
      status_loading: false,
      show_insert: false,
      status_seconder: false,
      status_approver: false,
      infoCancelled: false,
      text_info: '',
      seconder_ban: false,
      approver_ban: false,
      textAlert: '',
      infoCancelledModal: false,
      status_seconder_step: false,
      events: [],
      // status
      spring: false,
      summer: false,
      autumn: false,
      winter: false,
      not_show: true,

    }
  },
  methods: {


    storeData() {

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('items', JSON.stringify(this.allItems))
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/trustee/store_monitoring`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.message) {
              toast.success(response.message)

            }

          })
          .catch(error => {
            toast.error('خطا در ارتباط با سرور. لطفا دوباره تلاش کنید.');
          });
    },

    all() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('action_status', this.actionStatus)
      formdata.append('period', this.period)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/trustee/all_monitoring`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.setup) {
              this.spring = response.setup.spring
              this.summer = response.setup.summer
              this.autumn = response.setup.autumn
              this.winter = response.setup.winter
            }
            this.event = response.event
            this.allItems.length = 0
            if (response.step) {
              if ((parseInt(response.step) === 1 && this.type_two) || (parseInt(response.step) === 2 && this.type_two) || (parseInt(response.step) === 2 && this.type_one) || parseInt(response.step) === 3) {
                this.not_show = false
              }
            }
            if (response.events) {
              this.events = response.events
            }
            response.all.forEach((item) => {
              this.allItems.push(item)
            })
            this.is_fetch = false


          })
          .catch();
    },

    fetchItems() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/show`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.logout()
              return;
            }
            if (result['item']) {
              if (this.is_mother) {
                this.id_user = result['item']['id']
                return;
              }
              this.id_user = result['item']['company_id']

            }

          })
          .catch();
    },
    ProductivityPeriod() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/ProductivityPeriod/check`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.status) {
              this.isWrite = true
              return
            } else {
              this.isWrite = false
            }


          })
          .catch();
    },

    calculateDeviation(progress, target) {
      progress = parseFloat(progress) || 0;
      target = parseFloat(target) || 0;
      console.log(progress)
      console.log(target)
      const deviation = progress - target;
      return deviation > 0 ? deviation.toFixed(2) : '0';
    },
    updateItemDeviation(item) {
      item.spring_deviation = this.calculateDeviation(item.progress_spring, item.nature_type ? item.target_spring : item.target_spring_yes);
      item.summer_deviation = this.calculateDeviation(item.progress_summer, item.nature_type ? item.target_summer : item.target_summer_yes);
      item.autumn_deviation = this.calculateDeviation(item.progress_autumn, item.nature_type ? item.target_autumn : item.target_autumn_yes);
      item.winter_deviation = this.calculateDeviation(item.progress_winter, item.nature_type ? item.target_winter : item.target_winter_yes);
    },
  },

  computed: {
    sortedItems() {
      return this.allItems.map(item => ({
        ...item,
        spring_deviation: this.calculateDeviation(item.progress_spring, item.nature_type ? item.target_spring : item.target_spring_yes),
        summer_deviation: this.calculateDeviation(item.progress_summer, item.nature_type ? item.target_summer : item.target_summer_yes),
        autumn_deviation: this.calculateDeviation(item.progress_autumn, item.nature_type ? item.target_autumn : item.target_autumn_yes),
        winter_deviation: this.calculateDeviation(item.progress_winter, item.nature_type ? item.target_winter : item.target_winter_yes),
      }));
    }


  },
  watch: {
    allItems: {
      deep: true,
      handler(newItems) {
        newItems.forEach(this.updateItemDeviation);
      }
    },
    actionStatus: function () {
      this.all();
    },
    period: function () {
      this.all();
    },
  },

  mounted() {
    this.all()
    this.fetchItems()
    this.ProductivityPeriod()
    this.allItems.forEach(this.updateItemDeviation);


  }
}
</script>
<style scoped>
.input {
  display: block;
  margin-bottom: 1.5em;
  min-width: 10em;
}

.input:hover .input__support {
  border-color: #9fa8b2;
}

.input:hover .input__support:before {
  color: #7d8a96;
}

.input__text {
  display: block;
  padding-bottom: 0.5em;
  margin-left: 0.18em;
}

.input__text sup {
  color: #fe4f3e;
  cursor: help;
}

.input .input__support:before {
  display: none;

}

.input .input__support, .input .input__field {
  border-radius: 0;
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  line-height: 1.25;
  color: #464a4c;
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid #c1c7cd;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.input__field:focus + .input__support {
  border-color: #037DE4;
}

.input__field:valid + .input__support {
  border-color: #3742FA;
}

.input__field:valid + .input__support:before {
  content: "done";
  color: #3742FA;
}

.input__field:valid + .input__support .input__helper:before {
  content: "یک فایل انتخاب شده است";
  color: #7d8a96;
}

.input__field:invalid + .input__support:before {
  content: "file_upload";
}

.input__field:invalid + .input__support .input__helper:before {
  content: "انتخاب فایل (فرمت های قابل قبول: ورد-پی دی اف - اکسل-تصاویر)";
}

.input__support {
  display: flex !important;
  align-items: center;
}

.input__support:before {
  content: "file_upload";
  display: inline-block;
  color: #9fa8b2;
  width: 1.2rem;
  height: 1.2rem;
  margin: -0.5rem 0.5rem -0.5rem -0.2rem;
  transition: color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.input__helper:before {
  font-weight: 200;
  color: #9fa8b2;
  content: "Select file";
}

.input--file {
  cursor: pointer;
}

.input--file input[type=file] {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  padding: 0;
}

.sticky-header {
  position: sticky;
  top: 0;
  background-color: #fff; /* رنگ پس زمینه دلخواه را اضافه کنید */
  z-index: 2; /* این اطمینان می دهد که عنوان جدول در بالای محتوای دیگر ظاهر شود */
}

th.sticky-column, td.sticky-column {
  position: sticky;
  right: -.05vw;
  z-index: 3;
  box-shadow: inset .4vw 0 .4vw -.4vw rgba(255, 255, 255, 0.4);
}

th.sticky-column {
  background-color: #3742FA;
  z-index: 4;
}

td.sticky-column {
  background-color: #fff;
}

th.sticky-column-two, td.sticky-column-two {
  right: 23.8vw;
}

th.sticky-column-three, td.sticky-column-three {
  right: 30.6vw;
}

.filter-container {
  padding: 0 20vw;
}
</style>